import { Box, SxProps } from '@mui/material';

export interface FieldsAreaGridConfig {
  numberOfColumns?: number;
  lastChildConsumesRemainingSpace?: boolean;
}

export function FieldsArea({
  children,
  numberOfColumns = 1,
  lastChildConsumesRemainingSpace = true,
}: FieldsAreaGridConfig & { children: React.ReactNode }) {
  const gridTemplateColumns = `repeat(${numberOfColumns}, 1fr)`;
  const gridTemplateRows = 'repeat(auto-fit,min-content)';
  // makes last child consume remaining space of row
  const lastChildBehaviour: SxProps = lastChildConsumesRemainingSpace
    ? {
        ...[...Array(numberOfColumns)].reduce((acc, _, index) => {
          acc[
            `> div:nth-of-type(${numberOfColumns}n-${index + 1}):last-of-type`
          ] = {
            gridColumn: `${numberOfColumns - (index + 1)} / -1`,
          };
          return acc;
        }, {}),
      }
    : {};

  return (
    <Box
      sx={{
        display: 'grid',
        width: '100%',
        gap: '1rem',
        gridTemplateColumns,
        gridTemplateRows,
        ...lastChildBehaviour,
      }}
    >
      {children}
    </Box>
  );
}
